import {SplitText} from "gsap/SplitText";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
const isMobileFirstLoad = window.innerWidth < 768;

if (!isMobileFirstLoad) {

    const titleFaq = new SplitText(
        '.mksun-block-faq .timeline-text-reveal:not(.timeline-text-reveal--lines)',
        {
            type: 'words',
            wordsClass: 'word'
        }
    );

    const linesFaq = new SplitText('.mksun-block-faq .timeline-text-reveal--lines', {
        type: 'lines',
        linesClass: 'line'
    });

    const tlFaq = gsap.timeline({
        scrollTrigger: {
            trigger: '.mksun-block-faq'
        }
    });

    gsap.set(titleFaq.words, {
        y: '100%',
        opacity: 0
    });

    gsap.set(linesFaq.lines, {
        y: '100%',
        opacity: 0
    });

    tlFaq.to(
        titleFaq.words,
        {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tlFaq.to(
        linesFaq.lines,
        {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );
}

const dropdownsFaq = document.querySelectorAll(
    '.mksun-block-faq__ctn__dropdown'
);

dropdownsFaq.forEach((dropdown) => {
    dropdown
        .querySelector('.mksun-block-faq__ctn__dropdown__ask')
        .addEventListener('click', () => {
            const isOpen = dropdown.classList.toggle('open');

            if (!isOpen) {
                gsap.to(dropdown.querySelector('.mksun-block-faq__ctn__dropdown__answer'), {
                    height: 0,
                    paddingTop: 0,
                    paddingBottom: 0,
                    opacity: 0,
                    ease: 'back.in(3)'
                });
            } else {
                gsap.to(dropdown.querySelector('.mksun-block-faq__ctn__dropdown__answer'), {
                    duration: 0.5,
                    height: 'fit-content',
                    opacity: 1,
                    paddingTop: '1rem',
                    paddingBottom: '1rem',
                    ease: 'back.out(3)',
                    precision: 0.1,
                    onComplete: () => {
                        gsap.set(dropdown.querySelector('.mksun-block-faq__ctn__dropdown__answer'), {
                            height: 'auto'
                        });
                    }
                });
            }
        });
}, '<');});